import { Parent } from '@/models/Parent';
import { Individu } from '@/models/Individu';
import { MedecinDocument } from '@/models/MedecinDocument';
import { MaladieDocument } from '@/models/MaladieDocument';
import { Autorisations } from '@/models/Autorisations';
import { AllergieDocument } from '@/models/AllergieDocument';
import { VaccinDocument } from '@/models/VaccinDocument';
import { ChampLibreResultDocument } from '@/models/ChampLibreResultDocument';
import { ChampLibreDocument } from '@/models/ChampLibreDocument';
import { ChampLibreValeurDocument } from '@/models/ChampLibreValeurDocument';
import { ChampLibreResultValeurDocument } from '@/models/ChampLibreResultValeurDocument';
import { InformationIndividuDocument } from '@/models/InformationIndividuDocument';
import { DossierDocument } from '@/models/DossierDocument';

export interface InformationState {
  parents: Parent[];
  individu: Individu;
  medecin : MedecinDocument;
  maladies: MaladieDocument[];
  autorisations: Autorisations[];
  allergies : AllergieDocument[];
  vaccins : VaccinDocument[];
  famille_champs: ChampLibreResultDocument[];
  individu_champs: ChampLibreResultDocument[];
  champs_libres: ChampLibreDocument[];
  champs_libres_valeurs: ChampLibreValeurDocument[],
  Champs_libres_results_valeurs: ChampLibreResultValeurDocument[],
  information_individu: InformationIndividuDocument[],
  dossier: DossierDocument
}

export interface ChampLibreVO {
  id: number;
  intitule: string;
  values: string[];
}
export enum INFORMATION_STORE {
  /* commit */
  SET_PARENTS = "SET_PARENTS",
  SET_INDIVIDU = "SET_INDIVIDU",
  SET_MEDECIN = "SET_MEDECIN",
  SET_MALADIES = "SET_MALADIES",
  SET_AUTORISATIONS = "SET_AUTORISATIONS",
  SET_ALLERGIES = "SET_ALLERGIES",
  SET_VACCINS = "SET_VACCINS",
  SET_FAMILLE_CHAMPS = "SET_FAMILLE_CHAMPS",
  SET_INDIVIDU_CHAMPS = "SET_INDIVIDU_CHAMPS",
  SET_CHAMPS_LIBRES = "SET_CHAMPS_LIBRES",
  SET_CHAMPS_LIBRES_VALEURS = "SET_CHAMPS_LIBRES_VALEURS",
  SET_CHAMPS_LIBRES_RESULTS_VALEURS = "SET_CHAMPS_LIBRES_RESULTS_VALEURS",
  SET_INFORMATION_INDIVIDU = "SET_INFORMATION_INDIVIDU",
  SET_DOSSIER = "SET_DOSSIER"
}
